export default __webpack_public_path__ + "static/media/learose2-2048w.b7ac7f9a.avif";